import { planTypes } from '@/common/constants';

export const ZOOM_DEVICE_TYPE_MAP = {
  'edge': {
    type: planTypes.ZOOM_DEVICE$DESK_PHONE,
    title: 'billing.hw.desk_phones.addon.title',
  },
  'headset': {
    type: planTypes.ZOOM_DEVICE$HEADSET,
    title: 'billing.hw.headset.addon.title',
  },
}